import { create } from "zustand";

export type HelpTab = "hilfe" | "neuigkeiten" | "assistent";

interface HelpState {
	isOpen: boolean;
	activeTab: HelpTab;
	activeArticleSlug: string | null;
	unreadReleaseCount: number;
	assistantPrefill: string | null;
	toggleHelp: () => void;
	openHelp: (articleSlug?: string) => void;
	closeHelp: () => void;
	openArticle: (slug: string) => void;
	setActiveTab: (tab: HelpTab) => void;
	openReleases: () => void;
	setUnreadReleaseCount: (n: number) => void;
	openAssistant: (prefillMessage?: string) => void;
}

export const useHelpStore = create<HelpState>((set) => ({
	isOpen: false,
	activeTab: "hilfe",
	activeArticleSlug: null,
	unreadReleaseCount: 0,
	assistantPrefill: null,
	toggleHelp: () => set((state) => ({ isOpen: !state.isOpen })),
	openHelp: (articleSlug?: string) =>
		set({ isOpen: true, activeTab: "hilfe", activeArticleSlug: articleSlug || null }),
	closeHelp: () => set({ isOpen: false }),
	openArticle: (slug: string) =>
		set({ isOpen: true, activeTab: "hilfe", activeArticleSlug: slug }),
	setActiveTab: (tab: HelpTab) => set({ activeTab: tab }),
	openReleases: () => set({ isOpen: true, activeTab: "neuigkeiten" }),
	setUnreadReleaseCount: (n: number) => set({ unreadReleaseCount: n }),
	openAssistant: (prefillMessage?: string) =>
		set({ isOpen: true, activeTab: "assistent", assistantPrefill: prefillMessage || null }),
}));
